import React from 'react';
import { Button, Typography, ScreenContainer, LayoutControls, ContentFrame, } from '@pinwheel/origami';
import { useSelector } from 'react-redux';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import ModalHeader from '../../components/ModalHeader';
import TitleFrame from '../../LinkApiRouter/components/TitleFrame';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import { useSetAmountSelection } from '../../hooks/useSetAmountSelection';
import { selectLoadedPlatform } from '../../state/slices/slice-link-api';
var GuidedSwitchPrimerScreen = function () {
    var setAmountSelection = useSetAmountSelection();
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var loadedPlatform = useSelector(selectLoadedPlatform);
    return (React.createElement(ScreenContainer, null,
        React.createElement(ModalHeader, { showPlatformLogo: true, onBack: function () {
                // Since the login screen is before this (which navigates back to this screen), we need to manually navigate back twice
                navigate(-1);
                navigate(-1);
            } }),
        React.createElement(ContentFrame, { "data-testid": "GuidedSwitchPrimerScreen" },
            React.createElement(TitleFrame, { title: loadedPlatform === null || loadedPlatform === void 0 ? void 0 : loadedPlatform.name },
                React.createElement("div", { style: {
                        display: 'flex',
                        flex: 1,
                        flexDirection: 'column',
                    }, "data-testid": "GuidedSwitchPrimer" },
                    React.createElement(Typography, { variant: "body", sx: { textAlign: 'justify' } }, getLocalizedString('GUIDED_SWITCH_INTRO')),
                    React.createElement("ul", { "data-testid": "templateContinue__list", className: "templateContinue__list", style: {
                            textAlign: 'left',
                        } },
                        React.createElement("li", null,
                            React.createElement(Typography, { variant: "body" }, getLocalizedString('LEGAL_FIRST_LAST_NAME'))),
                        React.createElement("li", null,
                            React.createElement(Typography, { variant: "body" }, getLocalizedString('SOCIAL_SECURITY_NUMBER')))))),
            React.createElement(LayoutControls, null,
                React.createElement(Button, { eventId: "GuidedSwitchPrimerScreen-continue", dataTestId: "button", onClick: function () {
                        setAmountSelection({
                            action: 'full_switch',
                        });
                        // The below event is currently not needed, since we have only implemented guided switches for ENR
                        // platforms and this end user info is not required for ENRs. We will need it in the future when
                        // we implement for non-ENRs.
                        // fireClientEvent('end_user_info_required', {
                        //   type: 'verification',
                        //   endUserId: linkTokenPayload?.endUserId,
                        //   platformId: loadedPlatform?.id,
                        // });
                        navigate('/link-api/dds');
                    } }, getLocalizedString('CONTINUE'))))));
};
export default GuidedSwitchPrimerScreen;
